import { FC, useContext } from 'react';

import { CalculatorConfigContainer } from './calculatorconfigcontainer';
import { CalculatorOutputContainer } from './calculatoroutputcontainer';
import { Resources } from './resources';

import Context from '../context';

export const LAStorageCalculator: FC<{}> = () => {
    const { state } = useContext(Context);

    return (
        <div className="calc-container">
            <h1 className="calc-title">{Resources.CALCULATOR_TITLE}</h1>
            <div className="calc-description" tabIndex={0}>
                {Resources.CALCULATOR_DESCRIPTION}<p />{Resources.CALCULATOR_DISCLAIMER}
            </div>
            <div className="calc-body">
                <div className="calc-config-output-container"> 
                    <CalculatorConfigContainer />
                    { state.isCalculateClicked
                        ? <CalculatorOutputContainer />
                        : undefined
                    }
                </div>
            </div>
        </div>
    );
}
